import { ElementType, ClickType } from '@fiverr-private/bianka_js';
import { metric } from '../../events/metric';
import { reportBiEvent } from './reportBiEvent';
import { BiEventData, ReportBiEventParams } from './reportBiEvent.types';

export const reportNavigationCardClickEvent = (biEventData: BiEventData | undefined) => {
    const reportParams: ReportBiEventParams = {
        biEventData,
        activityType: 'click',
        eventType: 'clicked_on_model_card',
        elementName: 'generate',
        elementType: ElementType.BUTTON,
        clickType: ClickType.UNSPECIFIED,
    };

    const pageName = biEventData?.pageName || 'unknown';
    metric.count(`click.${pageName}`);

    reportBiEvent(reportParams);
};
